/**
 * Error Message Component
 * Displays error messages with optional retry button
 */

import React from 'react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div style={styles.container}>
      <div style={styles.iconContainer}>
        <span style={styles.icon}>⚠️</span>
      </div>
      <p style={styles.message}>{message}</p>
      {onRetry && (
        <button onClick={onRetry} style={styles.button}>
          تلاش مجدد
        </button>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    backgroundColor: '#fee',
    border: '1px solid #fcc',
    borderRadius: '8px',
    padding: '1rem',
    margin: '1rem 0',
    textAlign: 'center',
  },
  iconContainer: {
    marginBottom: '0.5rem',
  },
  icon: {
    fontSize: '2rem',
  },
  message: {
    color: '#c33',
    margin: '0.5rem 0',
    fontSize: '0.875rem',
  },
  button: {
    marginTop: '0.75rem',
    padding: '0.5rem 1.5rem',
    backgroundColor: '#c33',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '0.875rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
};
